import { __rest } from "tslib";
import React from 'react';
import { Toggle as MarvelToggle } from '@marvelapp/ui';
export function Toggle(_a) {
    var { disabled } = _a, props = __rest(_a, ["disabled"]);
    return (React.createElement(MarvelToggle, Object.assign({ activeColor: "primary", inactiveColor: "slate6", "data-testid": props.testId, disabled: disabled, opacity: disabled ? 0.5 : 1 }, props)));
}
